import '@/globals.css';
import { GuideShell } from '@/components/layout/GuideShell';
import { createRootRoute, Outlet } from '@tanstack/react-router';

export const Route = createRootRoute({
  component: RootLayout,
});

function RootLayout() {
  return (
    <GuideShell>
      <Outlet />
    </GuideShell>
  );
}
